var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"ecm__books_component",attrs:{"gutter":10}},_vm._l((_vm.books),function(book){return _c('el-col',{key:book.id,attrs:{"span":3}},[_c('Card',{attrs:{"book":book}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }